import { Auth } from './apiMaisdelivery/auth';
import { Address } from './apiMaisdelivery/address';
import { Shop } from './apiMaisdelivery/shop';

export interface HttpRequestI {
  error: boolean;
  loading: boolean;
  success: boolean;
  loadingBar: unknown;
  errorMsg: '';
}

class Api {
  readonly apiMaisdelivery = {
    auth: new Auth(),
    address: new Address(),
    shop: new Shop(),
  };
}

export const api = new Api();
